import { baseService } from './baseService'
import { STATUS_CODE } from '../data/system_settings'
import Response from '../data/entity/response_entity'
import { AccountCreateDTO } from '../data/entity/user_create_entity'
import { PAGE_SIZE } from '../data/queryFactories'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../utils/showToast'
function AccountDTO(payload) {
  if (!payload || typeof payload !== 'object') {
    throw new Error('Invalid payload: Payload must be a non-null object.')
  }

  const accountData = payload || {}

  return {
    uuid: accountData.uuid || 'N/A',
    name: accountData.fullName || 'N/A', // payload mới: fullName
    schoolId: accountData.schoolId || 'N/A', // payload mới: schoolId
    personalEmail: accountData.personalEmail || 'N/A',
    schoolEmail: accountData.schoolEmail || 'N/A',
    phoneNumber: accountData.phoneNumber || 'N/A',
    course: accountData.studentCourse || 'N/A', // payload mới: studentCourse
    major: accountData.major || 'N/A', // payload mới: major
    faculty: accountData.faculty || 'N/A',
    school: accountData.school || 'N/A',
    status: accountData.status || 'UNKNOWN',
    totalPayment:
      accountData.totalPayment !== undefined ? accountData.totalPayment : 0,
    groups: Array.isArray(accountData.groups)
      ? accountData.groups.map((group) => ({
          uuid: group.uuid || 'N/A',
          name: group.name || 'N/A',
          description: group.description || 'N/A',
          createdAt: group.createdAt || 0,
          createdBy: group.createdBy || 'N/A',
        }))
      : [],
    // Các trường sau không có trong payload mới, nên được comment lại:
    // devices: Array.isArray(accountData.devices) ? accountData.devices : [],
    // books: Array.isArray(accountData.books) ? accountData.books : [],
    // className: accountData.className || 'N/A',
    createdAt: accountData.createdAt || 0,
    createdBy: accountData.createdBy || 'N/A',
    updatedAt: accountData.updatedAt || 0,
    updatedBy: accountData.updatedBy || 'N/A',
  }
}
export class AccountService extends baseService {
  async search(payloads) {
    try {
      const payload = {
        pageSize: payloads?.pageSize ?? PAGE_SIZE,
        pageNumber: payloads?.pageNumber ?? 0,
        // payloads?.pageNumber ?? 1, // 0 vì ban đầu API có bug,
        keyword: payloads?.keywords ?? payloads.keyword ?? '',
        joinDate: payloads?.joinDate ?? undefined,
        groupName: payloads?.group ?? undefined,
      }

      const res = await this.post('users/search', payload)
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: res.data.data,
          },
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Vui lòng liên hệ admin',
          },
        })
      }
    } catch (error) {
      return Response({
        success: false,
        message: {
          content: 'Lỗi không xác định',
        },
      })
    }
  }
  async create({ bulk, payload }) {
    // Logic xử lý của hàm create
    try {
      if (!Array.isArray(payload)) {
        payload = [payload]
      }
      const res = await this.post('users/bulk-create', payload)
      if (res.status === STATUS_CODE.CREATED) {
        return handleCreateResponse({
          bulk: bulk,
          res: res.data.data,
          payload: payload,
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Lỗi không xác định',
          },
        })
      }
    } catch (error) {
      return handleError(error)
    }
  }
  async update({ uuid, payload }) {
    if (typeof uuid !== 'string') {
      return Response({
        success: false,
        message: {
          content: 'Kiểu dữ liệu không hợp lệ vui lòng liên hệ Admin',
        },
      })
    }
    try {
      const res = await this.put(`users/${uuid}`, payload)
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: 'Lưu dữ liệu thành công',
          },
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Lỗi không xác định',
          },
        })
      }
    } catch (error) {
      return Response({
        success: false,
        message: {
          content: 'Không xác định',
        },
      })
    }
  }
  async getByUuid(uuid, accessToken) {
    // const tempUuid = '2ce1939f-e112-4904-9f94-991d6f7d4aaa'
    if (typeof uuid !== 'string') {
      return Response({
        success: false,
        message: {
          content: 'Kiểu dữ liệu không hợp lệ vui lòng liên hệ Admin',
        },
      })
    }
    try {
      const res = await this.get(`users/${uuid}`, '', accessToken)

      // res.data.data.
      return Response({
        success: true,
        message: {
          content: res.data.data,
        },
      })
    } catch (error) {
      let message = 'Lỗi không xác định'
      const { status } = error.response
      switch (status) {
        case STATUS_CODE.NOT_FOUND:
          break
        default:
          message = message ? message : error.message
      }
      return Response({
        success: false,
        message: {
          content: message,
        },
      })
    }
  }
  async getMe(accessToken) {
    try {
      const res = await this.get(`users/me`, '', accessToken)
      return Response({
        success: true,
        message: {
          content: AccountDTO(res.data.data),
        },
      })
    } catch (error) {
      let message = 'Lỗi không xác định'
      const { status } = error.response
      switch (status) {
        case STATUS_CODE.NOT_FOUND:
          break
        default:
          message = message ? message : error.message
      }
      return Response({
        success: false,
        message: {
          content: message,
        },
      })
    }
  }
  async getUsersGuest(payloads) {
    try {
      const payload = {
        pageSize: payloads?.pageSize ?? PAGE_SIZE,
        pageNumber: payloads?.pageNumber ?? 0,
      }
      const res = await this.get('users/all/guests', payload)
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: res.data.data,
          },
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Vui lòng liên hệ admin',
          },
        })
      }
    } catch (error) {
      return Response({
        success: false,
        message: {
          content: 'Lỗi không xác định',
        },
      })
    }
  }
  async createAccountGuest(payloads) {
    showLoadingToast('Đang tạo tài khoản khách!', toastKey.ACCOUNT.GUEST.CREATE)
    try {
      const res = await this.post('users/create', payloads)
      if (res?.status === 201 && res?.data?.data) {
        showSuccessToast(
          'Tạo tài khoản khách thành công!',
          toastKey.ACCOUNT.GUEST.CREATE
        )
        return res
      } else {
        showErrorToast(
          'Lỗi tạo tài khoản!\n Vui lòng liên hệ admin',
          toastKey.ACCOUNT.GUEST.CREATE
        )
      }
    } catch (error) {
      showErrorToast({
        message: error?.response?.data?.meta?.message,
        error: error,
        toastId: toastKey.ACCOUNT.GUEST.CREATE,
      })
    }
  }
  async deleteAccountGuest(payload) {
    const dataGroups = {
      userUuids: payload.uuid,
      groupUuid: payload.groups
        ? payload.groups.split(', ').map((group) => group.trim())
        : [],
    }
    if (dataGroups.groupUuid.length > 0) {
      var groupIdList = []
      try {
        const groupUuid = await this.get(`groups/all`)
        if (!groupUuid) {
          throw new Error('Lấy nhóm người dùng thất bại')
        }
        groupIdList = dataGroups.groupUuid.map((groupName) => {
          return groupUuid.data.data.find((g) => g.name === groupName)?.uuid
        })
      } catch (error) {
        throw new Error('Lấy người dùng khỏi nhóm thất bại')
      }
      dataGroups.groupUuid = groupIdList
    }
    dataGroups?.groupUuid?.forEach(async (groupId) => {
      try {
        const resRemoveUserFromGroups = await this.post('groups/remove', {
          userUuids: [payload.uuid],
          groupUuid: groupId,
        })
        if (!resRemoveUserFromGroups) {
          showErrorToast(
            'Lỗi không xác định khi xóa người dùng khỏi nhóm!',
            toastKey.ACCOUNT.GROUP.REMOVE
          )
        }
      } catch (error) {
        showErrorToast({
          error: error,
          message: 'Xóa người dùng khỏi nhóm thất bại!',
          toastId: toastKey.ACCOUNT.GROUP.REMOVE,
        })
      }
    })
    const url = `users/guest/${payload.uuid}`
    try {
      const res = await this.delete(url)
      if (res.status !== 200) {
        showErrorToast(
          res?.data?.meta?.message || 'Lỗi không xác định!',
          toastKey.ACCOUNT.GUEST.DELETE
        )
      }
      showSuccessToast(
        'Xóa tài khoản khách thành công!',
        toastKey.ACCOUNT.GUEST.DELETE
      )
      //chờ api xóa user để xóa nốt tk khách ra khỏi bảng users
      // try{
      //   const deleteInDatabaseUsers = await this.delete()
      // }catch(error){
      //   throw new Error(error)
      // }
      return res?.data
    } catch (error) {
      showErrorToast({
        error: error,
        message: 'Xóa tài khoản khách thất bại!',
        toastId: toastKey.ACCOUNT.GUEST.DELETE,
      })
    }
  }
  async deleteAdmin(uuid) {
    try {
      showLoadingToast('Đang xóa quản trị viên!', toastKey.SYSTEM.ADMINS.DELETE)
      const res = await this.delete(`admin/${uuid}`)
      if (res?.status !== 200) {
        showErrorToast(
          res?.data?.meta?.message || 'Lỗi không xác định!',
          toastKey.SYSTEM.ADMINS.DELETE
        )
        return
      }
      showSuccessToast(
        'Xóa quản trị viên thành công!',
        toastKey.SYSTEM.ADMINS.DELETE
      )
      return res?.data
    } catch (error) {
      showErrorToast({
        error: error,
        message: 'Xóa quản trị viên thất bại!',
        toastId: toastKey.SYSTEM.ADMINS.DELETE,
      })
    }
  }
}

const handleCreateResponse = ({ bulk, res, payload }) => {
  // XỬ LÝ SO SÁNH
  //
  if (!bulk) {
    if (res[0]?.id == payload[0].id) {
      //
      //
      return Response({
        success: true,
        message: {
          data: res,
          content: 'Tạo tài khoản thành công',
        },
      })
    } else {
      throw new Error('Mã tài khoản đã tồn tại')
    }
  } else {
    const unCreatedUsers = [] // Chỉ chứa Id
    const createdUsers = []
    const idCreated = res.map((item) => item.Id)
    const idPayload = payload.map((item) => item.id)

    idPayload.forEach((item) => {
      if (idCreated.includes(item)) {
        createdUsers.push(item)
      } else {
        unCreatedUsers.push(item)
      }
    })

    return Response({
      success: true,
      message:
        idPayload.length == createdUsers.length
          ? `Tạo thành công ${createdUsers.length} tài khoản`
          : `Có ${createdUsers.length} tài khoản tạo thành công và ${unCreatedUsers.length} đã tồn tại trong hệ thống`,
    })
  }
}
const handleError = (error) => {
  let message = error.message || 'Lỗi không xác định'
  if (error.response) {
    const { status, data } = error.response
    message = data.meta.message || 'Lỗi không xác định'
    if (data.status === 'BAD_REQUEST') {
      message = 'Vui lòng kiểm tra lại dữ liệu'
    }
  }

  return Response({ success: false, message: { content: message } })
}

export const accountService = new AccountService()
